export default __webpack_public_path__ + "static/media/hp_slide1.104da544.jpg";